<template>
    <div
        class="fixed w-screen h-screen top-0 left-0 bg-black/60 z-20 flex items-center justify-center cursor-pointer"
        @keydown.esc="hide"
        @click.self.exact="hide"
    >
        <div class="rounded bg-base-100 shadow-lg cursor-auto flex flex-col w-[50em] p-3 z-40">
            <sub-account-editor
                :sub-account="subAccount"
                @created="refresh"
                @updated="save"
                @deleted="refresh"
            />
        </div>
    </div>
</template>


<script setup lang="ts">

import {ref} from 'vue'
import {CUSTOMER, SubAccount} from '@/subaccount/types/SubAccount'
import hotkeys from 'hotkeys-js'
import {fetchCustomers, fetchSuppliers} from '@/subaccount/subAccount.service'
import SubAccountEditor from '@/subaccount/SubAccountEditor.vue'

const props = defineProps({
    subAccount: {
        type: Object as () => SubAccount,
        required: true
    },
})

const showSucessToast = ref(false)
const emit = defineEmits(['close', 'updated'])
const hide = () => {
    emit('close')
}
hotkeys('esc', hide)

const refresh = async () => {
    if (props.subAccount.relationType === CUSTOMER) {
        await fetchCustomers()
    } else {
        await fetchSuppliers()
    }
    hide()
}

const save = async (account: SubAccount) => {
    showSucessToast.value = true
    emit('updated', account)
    await refresh()
}

</script>

<style scoped></style>